import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    nav_features: "Fonctionnalités",
    nav_how_it_works: "Comment ça marche",
    nav_preorder: "S'inscrire",
    nav_faq: "FAQ",
    nav_login: "Connexion",
    nav_logout: "Déconnexion",
    nav_dashboard: "Mon espace",
    
    // Hero
    hero_badge: "Bientôt sur Kickstarter",
    hero_title: "Le premier téléphone",
    hero_title_highlight: "sans écran",
    hero_title_end: "pour enfants",
    hero_subtitle: "Gardez le contact avec votre enfant en toute sécurité, sans risque d'exposition numérique. Conçu pour les enfants dès 3 ans.",
    hero_cta: "Me notifier du lancement",
    hero_cta_sub: "Prix de lancement : 79€ • Livraison prévue : Septembre 2026",
    hero_guarantee: "Prix préférentiel pour les premiers inscrits",
    
    // Problem/Solution
    problem_badge: "Le problème",
    problem_title: "Comment rester connecté à son enfant sans lui coller un écran ?",
    problem_text: "Vous voulez pouvoir appeler votre enfant, savoir où il est, mais sans lui donner accès à des jeux, des vidéos ou des réseaux sociaux.",
    solution_badge: "La solution",
    solution_title: "Calli : la connexion sans distraction",
    solution_text: "Un téléphone minimaliste qui permet à votre enfant d'appeler ses proches en appuyant sur leur photo. Pas d'écran, pas d'apps, pas de distraction.",
    
    // Features
    features_badge: "Fonctionnalités",
    features_title: "Tout ce dont votre enfant a besoin",
    features_subtitle: "Ni plus, ni moins",
    feature_calls_title: "Appels ultra-simples",
    feature_calls_desc: "8 boutons avec photos. Un bouton = une personne. Votre enfant appelle en un geste !",
    feature_battery_title: "Autonomie record",
    feature_battery_desc: "Jusqu'à 15 jours de batterie. Alerte automatique envoyée aux parents à 25%.",
    feature_gps_title: "Localisation discrète",
    feature_gps_desc: "Position envoyée automatiquement. Visualisation simple via l'application parent.",
    feature_security_title: "Sécurité maximale",
    feature_security_desc: "Aucune connexion Internet. Les numéros non autorisés ne peuvent pas appeler. Bouton urgence 112.",
    feature_control_title: "Contrôle parental",
    feature_control_desc: "Configuration simple via application. Désactivation possible à distance.",
    feature_design_title: "Design résistant",
    feature_design_desc: "Coque souple anti-chocs. Étanche IP54. Parfait pour les petites mains.",
    
    // How it works
    how_badge: "Comment ça marche",
    how_title: "Simple comme bonjour",
    how_step1_title: "1. Configurez",
    how_step1_desc: "Associez les photos des proches aux boutons via l'application parent.",
    how_step2_title: "2. Donnez",
    how_step2_desc: "Votre enfant appuie sur la photo de la personne qu'il veut appeler.",
    how_step3_title: "3. Connectez",
    how_step3_desc: "L'appel se lance en un clic. Simple !",
    
    // Preorder
    preorder_badge: "Précommande",
    preorder_title: "Réservez le vôtre",
    preorder_subtitle: "Soyez parmi les premiers à offrir la liberté sans écran",
    preorder_progress: "collectés",
    preorder_goal: "Objectif :",
    preorder_backers: "pré-commandes",
    preorder_price: "15€",
    preorder_price_info: "Acompte de réservation",
    preorder_final_price: "Prix final : 79€ à la livraison",
    preorder_cta: "Précommander maintenant",
    preorder_guarantee: "Remboursement intégral si l'objectif n'est pas atteint",
    preorder_delivery: "Livraison prévue : Septembre 2026",
    
    // FAQ
    faq_badge: "Questions fréquentes",
    faq_title: "Vos questions, nos réponses",
    faq_q1: "Mon enfant est-il trop petit pour Calli ?",
    faq_a1: "Calli est conçu pour les enfants dès 3 ans ! L'interface est 100% visuelle : votre enfant appuie simplement sur la photo de mamie ou papy pour les appeler. Pas besoin de savoir lire ni compter.",
    faq_q2: "Et si mon enfant perd ou casse Calli ?",
    faq_a2: "Calli est ultra-résistant avec sa coque anti-chocs et son étanchéité IP54. Et grâce à la localisation GPS, vous retrouvez Calli en quelques secondes via l'application parent.",
    faq_q3: "Comment je sais si mon enfant va vraiment l'utiliser ?",
    faq_a3: "Les enfants adorent Calli ! Appeler mamie en appuyant sur sa photo, c'est magique pour eux. Et vous, vous pouvez les appeler à tout moment. 95% des parents constatent que leur enfant utilise Calli quotidiennement.",
    faq_q4: "C'est vraiment sans danger pour mon enfant ?",
    faq_a4: "Absolument ! Zéro écran, zéro Internet, zéro publicité, zéro contenu inapproprié. Seuls les 8 contacts que VOUS choisissez peuvent appeler ou être appelés. Les numéros inconnus sont automatiquement bloqués.",
    faq_q5: "Que se passe-t-il si je précommande et que le projet n'aboutit pas ?",
    faq_a5: "Vous êtes remboursé intégralement, sans aucune question. C'est notre engagement : si l'objectif n'est pas atteint, vous récupérez 100% de votre acompte sous 7 jours.",
    faq_q6: "Pourquoi précommander maintenant plutôt qu'attendre ?",
    faq_a6: "En précommandant aujourd'hui, vous bénéficiez du prix de lancement exclusif (15€ d'acompte au lieu de 79€ direct). Plus important : vous faites partie des premiers parents à offrir cette liberté à leur enfant. Les stocks de la première série sont limités !",
    
    // Environmental
    eco_badge: "Engagements",
    eco_title: "Responsable par nature",
    eco_materials: "Matériaux durables",
    eco_materials_desc: "Coque en plastique recyclé ou biosourcé",
    eco_recycling: "Recyclage facilité",
    eco_recycling_desc: "Démontage facile et filière de reprise",
    eco_production: "Production responsable",
    eco_production_desc: "Partenaires certifiés ISO 14001",
    eco_packaging: "Packaging éco-conçu",
    eco_packaging_desc: "Zéro plastique superflu",
    
    // Footer
    footer_tagline: "Le premier téléphone sans écran pour enfants",
    footer_product: "Produit",
    footer_company: "Entreprise",
    footer_legal: "Légal",
    footer_about: "À propos",
    footer_contact: "Contact",
    footer_press: "Presse",
    footer_privacy: "Confidentialité",
    footer_terms: "CGV",
    footer_refund: "Remboursement",
    footer_newsletter: "Newsletter",
    footer_newsletter_placeholder: "Votre email",
    footer_newsletter_button: "S'inscrire",
    footer_copyright: "© 2026 Calli. Tous droits réservés.",
    
    // Auth Modal
    auth_title: "Connectez-vous pour précommander",
    auth_google: "Continuer avec Google",
    auth_email: "Continuer avec Email",
    auth_or: "ou",
    auth_email_label: "Email",
    auth_password_label: "Mot de passe",
    auth_name_label: "Nom complet",
    auth_login: "Se connecter",
    auth_register: "Créer un compte",
    auth_switch_register: "Pas de compte ? Inscrivez-vous",
    auth_switch_login: "Déjà un compte ? Connectez-vous",
    auth_error: "Erreur de connexion",
    
    // Dashboard
    dashboard_title: "Votre précommande",
    dashboard_confirmed: "Confirmée",
    dashboard_amount: "Montant payé",
    dashboard_date: "Date de précommande",
    dashboard_delivery: "Livraison estimée",
    dashboard_delivery_date: "Septembre 2026",
    dashboard_share: "Partager avec vos amis",
    dashboard_share_text: "J'ai précommandé Calli, le premier téléphone sans écran pour enfants !",
    dashboard_no_preorder: "Vous n'avez pas encore de précommande",
    dashboard_preorder_now: "Précommander maintenant",
    
    // Success
    success_title: "Félicitations !",
    success_message: "Votre précommande est confirmée. Vous recevrez un email de confirmation.",
    success_share: "Partagez la nouvelle !",
  },
  en: {
    // Navigation
    nav_features: "Features",
    nav_how_it_works: "How it works",
    nav_preorder: "Sign up",
    nav_faq: "FAQ",
    nav_login: "Login",
    nav_logout: "Logout",
    nav_dashboard: "Dashboard",
    
    // Hero
    hero_badge: "Coming soon to Kickstarter",
    hero_title: "The first",
    hero_title_highlight: "screenless",
    hero_title_end: "phone for kids",
    hero_subtitle: "Stay connected with your child safely, without digital exposure risks. Designed for children from 3 years.",
    hero_cta: "Notify me at launch",
    hero_cta_sub: "Launch price: €79 • Delivery: September 2026",
    hero_guarantee: "Special price for early subscribers",
    
    // Problem/Solution
    problem_badge: "The problem",
    problem_title: "How to stay connected to your child without giving them a screen?",
    problem_text: "You want to call your child, know where they are, but without giving them access to games, videos or social media.",
    solution_badge: "The solution",
    solution_title: "Calli: connection without distraction",
    solution_text: "A minimalist phone that lets your child call loved ones by pressing their photo. No screen, no apps, no distraction.",
    
    // Features
    features_badge: "Features",
    features_title: "Everything your child needs",
    features_subtitle: "Nothing more, nothing less",
    feature_calls_title: "Ultra-simple calls",
    feature_calls_desc: "8 buttons with photos. One button = one person. Your child calls with a single touch!",
    feature_battery_title: "Record battery life",
    feature_battery_desc: "Up to 15 days of battery. Automatic alert sent to parents at 25%.",
    feature_gps_title: "Discreet location",
    feature_gps_desc: "Position sent automatically. Simple viewing via parent app.",
    feature_security_title: "Maximum security",
    feature_security_desc: "No Internet connection. Unauthorized numbers cannot call. Emergency 112 button.",
    feature_control_title: "Parental control",
    feature_control_desc: "Simple setup via app. Remote disable possible.",
    feature_design_title: "Tough design",
    feature_design_desc: "Shock-resistant soft case. IP54 waterproof. Perfect for little hands.",
    
    // How it works
    how_badge: "How it works",
    how_title: "Simple as ABC",
    how_step1_title: "1. Configure",
    how_step1_desc: "Link photos of loved ones to buttons via the parent app.",
    how_step2_title: "2. Give",
    how_step2_desc: "Your child presses the photo of the person they want to call.",
    how_step3_title: "3. Connect",
    how_step3_desc: "The call starts with a single click. Simple!",
    
    // Preorder
    preorder_badge: "Preorder",
    preorder_title: "Reserve yours",
    preorder_subtitle: "Be among the first to offer screen-free freedom",
    preorder_progress: "collected",
    preorder_goal: "Goal:",
    preorder_backers: "preorders",
    preorder_price: "€15",
    preorder_price_info: "Reservation deposit",
    preorder_final_price: "Final price: €79 on delivery",
    preorder_cta: "Preorder now",
    preorder_guarantee: "Full refund if goal is not reached",
    preorder_delivery: "Expected delivery: September 2026",
    
    // FAQ
    faq_badge: "FAQ",
    faq_title: "Your questions, our answers",
    faq_q1: "Is my child too young for Calli?",
    faq_a1: "Calli is designed for children from 3 years! The interface is 100% visual: your child simply presses grandma's or grandpa's photo to call them. No need to read or count.",
    faq_q2: "What if my child loses or breaks Calli?",
    faq_a2: "Calli is ultra-resistant with its shock-proof case and IP54 water resistance. And thanks to GPS location, you can find Calli in seconds via the parent app.",
    faq_q3: "How do I know if my child will actually use it?",
    faq_a3: "Kids love Calli! Calling grandma by pressing her photo is magical for them. And you can call them anytime. 95% of parents report their child uses Calli daily.",
    faq_q4: "Is it really safe for my child?",
    faq_a4: "Absolutely! Zero screen, zero Internet, zero ads, zero inappropriate content. Only the 8 contacts YOU choose can call or be called. Unknown numbers are automatically blocked.",
    faq_q5: "What happens if I preorder and the project doesn't succeed?",
    faq_a5: "You get a full refund, no questions asked. That's our commitment: if the goal isn't reached, you get 100% of your deposit back within 7 days.",
    faq_q6: "Why preorder now instead of waiting?",
    faq_a6: "By preordering today, you get the exclusive launch price (€15 deposit instead of €79 upfront). More importantly: you'll be among the first parents to give this freedom to their child. First batch quantities are limited!",
    
    // Environmental
    eco_badge: "Commitments",
    eco_title: "Responsible by nature",
    eco_materials: "Sustainable materials",
    eco_materials_desc: "Shell made of recycled or bio-based plastic",
    eco_recycling: "Easy recycling",
    eco_recycling_desc: "Easy disassembly and take-back program",
    eco_production: "Responsible production",
    eco_production_desc: "ISO 14001 certified partners",
    eco_packaging: "Eco-designed packaging",
    eco_packaging_desc: "Zero unnecessary plastic",
    
    // Footer
    footer_tagline: "The first screenless phone for children",
    footer_product: "Product",
    footer_company: "Company",
    footer_legal: "Legal",
    footer_about: "About",
    footer_contact: "Contact",
    footer_press: "Press",
    footer_privacy: "Privacy",
    footer_terms: "Terms",
    footer_refund: "Refund",
    footer_newsletter: "Newsletter",
    footer_newsletter_placeholder: "Your email",
    footer_newsletter_button: "Subscribe",
    footer_copyright: "© 2026 Calli. All rights reserved.",
    
    // Auth Modal
    auth_title: "Sign in to preorder",
    auth_google: "Continue with Google",
    auth_email: "Continue with Email",
    auth_or: "or",
    auth_email_label: "Email",
    auth_password_label: "Password",
    auth_name_label: "Full name",
    auth_login: "Sign in",
    auth_register: "Create account",
    auth_switch_register: "No account? Sign up",
    auth_switch_login: "Already have an account? Sign in",
    auth_error: "Login error",
    
    // Dashboard
    dashboard_title: "Your preorder",
    dashboard_confirmed: "Confirmed",
    dashboard_amount: "Amount paid",
    dashboard_date: "Preorder date",
    dashboard_delivery: "Estimated delivery",
    dashboard_delivery_date: "September 2026",
    dashboard_share: "Share with friends",
    dashboard_share_text: "I preordered Calli, the first screenless phone for kids!",
    dashboard_no_preorder: "You don't have a preorder yet",
    dashboard_preorder_now: "Preorder now",
    
    // Success
    success_title: "Congratulations!",
    success_message: "Your preorder is confirmed. You will receive a confirmation email.",
    success_share: "Share the news!",
  }
};

const LanguageContext = createContext();

// Detect browser language
const detectBrowserLanguage = () => {
  // Check if user has a saved preference
  const saved = localStorage.getItem('calli_language');
  if (saved) return saved;
  
  // Detect browser language
  const browserLang = navigator.language || navigator.userLanguage || 'en';
  
  // If French (fr, fr-FR, fr-CA, etc.), use French
  if (browserLang.toLowerCase().startsWith('fr')) {
    return 'fr';
  }
  
  // Default to English for all other languages
  return 'en';
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => detectBrowserLanguage());

  useEffect(() => {
    localStorage.setItem('calli_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
